import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Stethoscope } from "lucide-react";
import { CONTACT, CLINICS, DOCTOR } from "@/data/site";

export const Footer = () => {
  return (
    <footer className="bg-brand-ink text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-white text-brand-primary">
                <Stethoscope className="h-5 w-5" />
              </span>
              <span className="font-heading text-lg font-extrabold">
                Advanced ENT Surgery Centre
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/70">
              {DOCTOR.name}, {DOCTOR.qualifications} — {DOCTOR.title} in
              Varanasi with {DOCTOR.experienceYears} years of surgical
              experience.
            </p>
            <div className="mt-5 space-y-2 text-sm">
              <a
                href={`tel:${CONTACT.phoneRaw}`}
                className="flex items-center gap-2 text-white/80 transition-colors hover:text-white"
                data-testid="footer-phone"
              >
                <Phone className="h-4 w-4" /> {CONTACT.phone}
              </a>
              <a
                href={`mailto:${CONTACT.email}`}
                className="flex items-center gap-2 text-white/80 transition-colors hover:text-white"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4" /> {CONTACT.email}
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-brand-soft">
              Explore
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/surgery-guide", label: "ENT Surgery Guide" },
                { to: "/faqs", label: "Surgery FAQs" },
                { to: "/recovery", label: "Recovery Guide" },
                { to: "/contact", label: "Contact & Booking" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/70 transition-colors hover:text-white"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {CLINICS.map((c, i) => (
            <div key={i}>
              <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-brand-soft">
                {c.name}
              </h4>
              <p className="mt-4 flex gap-2 text-sm text-white/70">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0" />
                <span>{c.address}</span>
              </p>
              <p className="mt-3 flex items-center gap-2 text-sm text-white/70">
                <Clock className="h-4 w-4 flex-shrink-0" />
                {c.timings}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-white/10 pt-6">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Advanced ENT Surgery Centre, Varanasi.
            All rights reserved. This website is for informational purposes and
            does not replace professional medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
};
